// npm optional packages

import { UnifyTables } from '@sop/unify-datatables';
import { InitHighChart } from '@sop/unify-highcharts';
import { UnifyRangeslider } from '@sop/unify-rangeslider';
import * as twitterBootstrapWizard from '@sop/unify-twitterbootstrapwizard';

export class UnifyExtendedNpm {
    constructor() {

    }

    initialize(o) {
        o = typeof o !== 'undefined' ? o : {};
        var brandedColors = typeof o.brandedColors !== 'undefined' ? o.brandedColors : '';
        var colorScheme = typeof o.colorScheme !== 'undefined' ? o.colorScheme : true;
        var exports = typeof o.exports !== 'undefined' ? o.exports : undefined;

        if (brandedColors === '') {
            console.log('Error UnifyExtendedNpm, need to be initialized with brandedColors, o:', o);
            return;
        }

        if (colorScheme === '') {
            console.log('Error UnifyExtendedNpm, need to be initialized with colorScheme, o:', o);
            return;
        }
        this.brandedColors = brandedColors;
        this.colorScheme = colorScheme;
        this.exports = exports;
    }

    loadDataTables() {
        UnifyTables.AddUnifyTableResponsiveToJquery($);
        this.exports.DataTables = UnifyTables;
        this.exports.dataTables = new UnifyTables();
        this.exports.dataTables.addDataTablesToJquery(window, $);
    }

    loadHighChart() {
        var initHighChart = new InitHighChart();
        initHighChart.initalize(this.brandedColors, this.colorScheme, this.exports);
    }

    loadRangeSlider() {
        var rangeSlider = new UnifyRangeslider();
    }
}